import {map} from 'lodash'
import {entities} from '../commonTypes'

const d3 = require('d3')

export const getColors = (options: entities.Option[]) => {
  return d3.scaleOrdinal().domain(map(options, 'value')).range(d3.schemeSet1)
}
